// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

export class InstrumentLookupComparer
{
    static sortInstrumentList (instrumentList, pattern)
    {
        let instrumentSample = pattern.toLowerCase()

        instrumentList.sort(InstrumentLookupComparer.compareInstruments.bind(null, instrumentSample))

        return instrumentList
    }

    static compareInstruments (instrumentSample, a, b)
    {
        let result = String.CompareOrdinal(a.isOptionSymbol, b.isOptionSymbol)

        if (!result)
        {
            if (a.isOptionSymbol && b.isOptionSymbol)
            {
                if (a.ForwardBaseInstrument != null && b.ForwardBaseInstrument != null)
                    result = String.CompareOrdinal(a.ForwardBaseInstrument.DisplayName().toLowerCase(), b.ForwardBaseInstrument.DisplayName().toLowerCase())

                if (!result)
                    if (a.ExpDate != b.ExpDate)
                        result = a.ExpDate > b.ExpDate ? 1 : -1

                if (!result)
                    if (a.StrikePrice != b.StrikePrice)
                        result = a.StrikePrice > b.StrikePrice ? 1 : -1     // #113023
                    else
                        result = a.PutCall > b.PutCall ? 1 : -1             // #113012

            }
            else if (a.isFuturesSymbol && b.isFuturesSymbol)
            {
                result = String.CompareOrdinal(a.InstrumentSpecificType, b.InstrumentSpecificType)

                if (!result)
                    if (a.ExpDate != b.ExpDate)
                        result = a.ExpDate > b.ExpDate ? 1 : -1
            }
            else
            {
                if (instrumentSample.length)
                {
                    let aDisplayName = a.DisplayName().toLowerCase(), bDisplayName = b.DisplayName().toLowerCase(),
                        aDescription = a.Description.toLowerCase(), bDescription = b.Description.toLowerCase()

                    let resultObj = { value: result }

                    if (InstrumentLookupComparer.TryCompareByFullMatch(aDisplayName, bDisplayName, instrumentSample, resultObj))
                    {
                        result = resultObj.value
                        if (result == 0)
                            result = String.CompareOrdinal(aDescription, bDescription)
                        return result
                    }
                    else if (InstrumentLookupComparer.TryCompareByPartialMatch(aDisplayName, bDisplayName, instrumentSample, resultObj))
                        return resultObj.value
                    else if (InstrumentLookupComparer.TryCompareByFullMatch(aDescription, bDescription, instrumentSample, resultObj))
                        return resultObj.value
                    else if (InstrumentLookupComparer.TryCompareByPartialMatch(aDescription, bDescription, instrumentSample, resultObj))
                        return resultObj.value
                    else
                        result = String.CompareOrdinal(aDisplayName, bDisplayName)
                }
                else
                    result = String.CompareOrdinal(a.DisplayName().toLowerCase(), b.DisplayName().toLowerCase())
            }

        }

        return result
    }

    static TryCompareByFullMatch (a, b, instrumentSample, result)
    {
        //Priority 1 Full match with pattern
        let aIsFullMatch = a == instrumentSample;
        let bIsFullMatch = b == instrumentSample;

        result.value = String.CompareOrdinal(bIsFullMatch, aIsFullMatch);

        //Both have full match
        if (result.value == 0 && aIsFullMatch)
            return true;
        return result.value != 0;
    }

    static TryCompareByPartialMatch (a, b, instrumentSample, result)
    {
        //Priority 2  Start with
        let aIsStartWith = a.indexOf(instrumentSample) == 0;
        let bIsStartWith = b.indexOf(instrumentSample) == 0;
        result.value = String.CompareOrdinal(bIsStartWith, aIsStartWith);

        //Both starts with pattern
        if (result.value == 0 && aIsStartWith)
        {
            result.value = String.CompareOrdinal(a, b);
            return true;
        }

        //Priority 3 Contains pattern
        let aIsContains = false;
        if (result.value == 0)
        {
            aIsContains = a.indexOf(instrumentSample) >= 0;
            let bIsContains = b.indexOf(instrumentSample) >= 0;
            result.value = String.CompareOrdinal(bIsContains, aIsContains)
        }

        //Both contains pattern
        if (result.value == 0 && aIsContains)
        {
            result.value = String.CompareOrdinal(a, b);
            return true;
        }

        return result.value != 0;
    }
}